<template>
  <div class="tabulka" :class="TableWidth">
    <div class="tabulka__top">
      <div class="tabulka__top__nadpis">Financial overview</div>
      <!-- <BalanceList /> -->
    </div>

    <div class="tabulka__body">
      <table>
        <thead>
          <td>
            <span>Round</span>
            <SortButton
              row="turn"
              type="0"
              :currentSortDirection="currentSortDirection"
              :currentSortRow="currentSortRow"
              v-on:sortBy="sortRow"
            />
          </td>
          <td class="right">
            <SortButton
              row="earned"
              type="0"
              :currentSortDirection="currentSortDirection"
              :currentSortRow="currentSortRow"
              v-on:sortBy="sortRow"
              floatRight="yes"
            />
            <span>Earned</span>
          </td>
          <td class="right">
            <SortButton
              row="spent"
              type="0"
              :currentSortDirection="currentSortDirection"
              :currentSortRow="currentSortRow"
              v-on:sortBy="sortRow"
              floatRight="yes"
            />
            <span>Spent</span>
          </td>
        </thead>
        <tr v-if="this.sourceData.length <= 1">
          <td>{{ $t(`texts.data.no-rounds-completed`) }}</td>
        </tr>

        <tr
          v-else
          v-for="(round, i) in sortedData"
          :key="`FinancialOverview-${i}`"
          v-show="round.turn > 0"
        >
          <td class="important">
            <span>{{ round.turn }}.</span>
          </td>
          <td class="right" :class="{ green: round.earned > 0 }">
            {{ round.earned | numbersThousands | inCurrency }}
          </td>
          <td class="right" :class="{ red: round.spent > 0 }">
            <span v-if="round.spent > 0">-</span
            >{{ round.spent | numbersThousands | inCurrency }}
          </td>
        </tr>
      </table>
    </div>
  </div>
</template>

<script>
import SortButton from "@/components/game/table/SortButton.vue";
import sortingLogicMixin from "@/components/game/table/sortingLogicMixin.js"; // obsahuje logiku k sortovani
import { mapGetters, mapActions } from "vuex";

export default {
  name: "FinancialOverview",
  mixins: [sortingLogicMixin],
  props: {
    TableWidth: String,
  },
  components: {
    SortButton,
  },
  data() {
    return {
      currentSortRow: "turn",
      currentSortDirection: -1,
    };
  },
  computed: {
    ...mapGetters({
      sourceData: "teamFinancialOverview",
    }),
  },
};
</script>
